// Error panel — message + Cancel / Try again. Cancel does a full reset
// (back to idle); Try again returns to picking with cleared progress +
// errorInfo, preserving any files already selected? — no, picking
// transitions also clear progress; files remain so the user can adjust
// the selection.

export default function ErrorUI({ state, handlers }) {
  const { errorInfo } = state;
  const { reset, goPicking } = handlers;

  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 shadow-sm">
      <p className="text-sm font-semibold text-red-800">
        Couldn't import this document
      </p>
      <p className="mt-1 text-sm text-red-900">
        {errorInfo?.errorMessage || "Something went wrong."}
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button
          type="button"
          onClick={reset}
          className="rounded-lg border border-red-200 bg-white px-3 py-1.5 text-sm text-red-800 hover:bg-red-100"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={goPicking}
          className="rounded-lg bg-red-700 px-3 py-1.5 text-sm text-white hover:bg-red-800"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
